import { createSlice } from "@reduxjs/toolkit";
import { getState } from "@bd-stores/store";

const initialState = {
  buildingBlocksAnswer: {},
};

const gameDataSlice = createSlice({
  name: "gameData",
  initialState,
  reducers: {
    /**
     * @param {typeof initialState} state
     * @param {import("@reduxjs/toolkit").PayloadAction<BD_StoreGameData['buildingBlocksAnswer']>} action
     */
    setBuildingBlocksAnswer: (state, action) => ({
      ...state,
      buildingBlocksAnswer: action.payload,
    }),
  },
});

export const getBuildingBlockAnswer = (id) => {
  const buildingBlocks = getState().gameData.buildingBlocksAnswer;
  const buildingBlock =
    buildingBlocks?.[id] ||
    buildingBlocks?.[String(id)] ||
    buildingBlocks?.[Number(id)] ||
    {};
  return buildingBlock;
};

/**
 * Normalize correct_answers from Firebase setup (object) or PHP config (array).
 * @param {unknown} correctAnswers
 * @returns {string[]}
 */
export const getCorrectAnswerStrings = (correctAnswers) => {
  if (!correctAnswers) return [];

  if (Array.isArray(correctAnswers)) {
    return correctAnswers
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item.correct_answer === "string") {
          return item.correct_answer;
        }
        return "";
      })
      .filter(Boolean);
  }

  if (typeof correctAnswers === "object") {
    return Object.values(correctAnswers).filter(
      (value) => typeof value === "string" && value.length > 0,
    );
  }

  return [];
};

/**
 * @param {string|number} id
 * @returns {string[]}
 */
export const getBlockCorrectAnswerStrings = (id) => {
  const blockAnswer = getBuildingBlockAnswer(id);
  return getCorrectAnswerStrings(blockAnswer?.correct_answers);
};

export const { setBuildingBlocksAnswer } = gameDataSlice.actions;
export const gameData = gameDataSlice.reducer;
